import { render, staticRenderFns } from "./UiBaseMenuDropdown.vue?vue&type=template&id=1a1ef7c2&"
import script from "./UiBaseMenuDropdown.vue?vue&type=script&lang=js&"
export * from "./UiBaseMenuDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UiBaseMenuDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports